<template>
  <el-dialog :title="$t('communityRecommend.linkGoods')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="addShopRecommendInfo" ref="addForm" label-width="120px" :rules="rules">
      <el-form-item :label="$t('communityRecommend.selectProduct')">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-select v-model="addShopRecommendInfo.shopId" style="width:100%" @change="queryAShopGoods"
              :placeholder="$t('communityRecommend.selectShop')">
              <el-option v-for="item in addShopRecommendInfo.shops" :key="item.shopId" :label="item.shopName"
                :value="item.shopId">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-select v-model="addShopRecommendInfo.prodId" style="width:100%" @change="selectGoods"
              :placeholder="$t('communityRecommend.selectProduct')">
              <el-option v-for="item in addShopRecommendInfo.products" :key="item.productId" :label="item.prodName"
                :value="item.productId">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.logo')" prop="logo">
        <upload-image-url ref="uploadImage" :callBackListener="'addShopRecommend'"
          :callBackFunction="'notifyUploadCoverImage'" :imageCount="1">
        </upload-image-url>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.productName')" prop="prodName">
        <el-input v-model="addShopRecommendInfo.prodName" :placeholder="$t('communityRecommend.requiredProductName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('communityRecommend.price')" prop="price">
        <el-input v-model="addShopRecommendInfo.price" :placeholder="$t('communityRecommend.requiredPrice')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveShopRecommendInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCommunityRecommend, queryShopsByAdmin, queryProduct } from '@/api/phone/communityRecommend/communityRecommendApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'AddShopRecommend',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      addShopRecommendInfo: {
        communityId: '',
        communityName: '',
        shopName: '',
        shopId: '',
        prodId: '',
        recommendType: 'GOODS',
        logo: '',
        prodName: '',
        price: '',
        url: '',
        shops: [],
        products: []
      },
      rules: {
        logo: [
          { required: true, message: this.$t('communityRecommend.logoRequired'), trigger: 'blur' }
        ],
        prodName: [
          { required: true, message: this.$t('communityRecommend.productNameRequired'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('communityRecommend.priceRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.addShopRecommendInfo.communityId = params.communityId
      this.addShopRecommendInfo.communityName = params.communityName
      this._listAShopRecommendShops()
      this.$nextTick(() => {
        this.$refs.uploadImage.clearImage()
      })
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.clearAddShopRecommendInfo()
    },
    async saveShopRecommendInfo() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.addShopRecommendInfo.url = `/pages/goods/goods?productId=${this.addShopRecommendInfo.prodId}&shopId=${this.addShopRecommendInfo.shopId}`
          try {
            await saveCommunityRecommend(this.addShopRecommendInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('保存失败:', error)
          }
        }
      })
    },
    clearAddShopRecommendInfo() {
      this.addShopRecommendInfo = {
        communityId: '',
        communityName: '',
        shopName: '',
        shopId: '',
        prodId: '',
        recommendType: 'GOODS',
        logo: '',
        prodName: '',
        price: '',
        url: '',
        shops: [],
        products: []
      }
    },
    async _listAShopRecommendShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.addShopRecommendInfo.shops = res.data
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    queryAShopGoods() {
      const shop = this.addShopRecommendInfo.shops.find(item => item.shopId === this.addShopRecommendInfo.shopId)
      if (shop) {
        this.addShopRecommendInfo.shopName = shop.shopName
      }
      this._listAGoodsProducts()
    },
    async _listAGoodsProducts() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 500,
          shopId: this.addShopRecommendInfo.shopId
        })
        this.addShopRecommendInfo.products = res.data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    selectGoods() {
      const product = this.addShopRecommendInfo.products.find(item => item.productId === this.addShopRecommendInfo.prodId)
      if (product) {
        this.addShopRecommendInfo.prodName = product.prodName
        this.addShopRecommendInfo.price = product.price
        this.addShopRecommendInfo.logo = product.coverPhoto
        this.$refs.uploadImage.notifyPhotos([product.coverPhoto])
      }
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>